import { fromUnixTime, isSameDay } from "date-fns";
import { FormattedChatMessage } from "../../app/types";

const areMessagesSameDay = (
  a?: FormattedChatMessage,
  b?: FormattedChatMessage,
) => {
  if (!a || !b) {
    return false;
  }

  return isSameDay(fromUnixTime(a.createdAt), fromUnixTime(b.createdAt));
};

export default areMessagesSameDay;
